import React from 'react'
import { Link } from 'gatsby'
import styles from './about.module.scss'

import Img from 'gatsby-image'

export default ({ image1, image2 }) => (
  <div className={styles.about}>
    <div className="wrapper">
      <div className={styles.aboutRow}>
        <div className={styles.aboutRowMedia}>
          <h2 className={styles.hashtag}>
            <span>#</span>
            abergymnastics
          </h2>
        </div>
        <div className={styles.aboutRowText}>
          <h3 className={`${styles.rowTitle} heading h3`}>
            Development & Growth
          </h3>
          <p className="body">
            Our gymnasts have represented the County in Schools Competitions and
            are constantly winning medals at competitions. It is our aim to
            promote the sport of gymnastics to the best possible level and also
            enable the gymnasts to enjoy the sport. We are committed to the
            welfare and protection of all our members both adult and children
            and are affiliated to both Welsh Gymnastics and British Gymnastics.
          </p>
        </div>
      </div>
      <div className={styles.aboutRow}>
        <div className={`${styles.aboutRowMediaShort} divider-up `}>
          <Img fluid={image1.node.fluid} style={{ height: '100%' }} />
        </div>
        <div className={`${styles.aboutRowLongText}`}>
          <h3 className={`${styles.rowTitle} heading h3`}>Joining the club</h3>
          <p className="body">
            On joining the club you will be given a membership pack which
            includes details of the club, Welfare Policies and a membership
            form. After three trial sessions, the gymnast is required to join
            the club for an annual fee.
          </p>
          <p className="body">
            This membership includes membership to Welsh Gymnastics and British
            Gymnastics. This is a requirement by our governing body. No gymnast
            can train without membership to Welsh/British Gymnastics. We are
            constantly assessing the ability of the gymnasts within the club and
            regularly have squad trials to give all the gymnasts the opportunity
            to improve.
          </p>
        </div>
      </div>
      <div className={styles.aboutRow}>
        <div className={`${styles.aboutRowMediaShort} divider-up `}>
          <Img fluid={image2.node.fluid} style={{ height: '100%' }} />
        </div>
        <div className={`${styles.aboutRowLongText}`}>
          <h3 className={`${styles.rowTitle} heading h3`}>Our day to day</h3>
          <p className="body">
            Our current squads train for approximately 8/9 hours a week (more
            when a competition is near). During the school holidays, we run
            ‘Gymnastic Camps’, both recreational and squad camps.
          </p>
          <p className="body">
            These camps run one or two days a week from 10am to 4pm and consist
            of fun and games with a gymnastic theme. All our coaches are
            voluntary and gymnastics is their hobby. They are all CRB checked
            and have undertaken the relevant Child Protection Courses.
          </p>
        </div>
      </div>
    </div>
  </div>
)
